
<template>
  <v-form ref="form" class="mt-3 mx-3">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>


      <v-col cols="12" sm="6">
        <v-autocomplete
          v-model="entry.harvestId"
          v-bind="getObject('harvestId')"
          label="Safra"
          :items="extraData.accountContext.allHarvests"
          item-value="id"
          item-text="name"
          no-data-text="Nenhuma Safra encontrada, faça outra busca"
          autocomplete="off"
          :disabled="readOnly">
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6">
        <v-autocomplete
          v-model="entry.cultureId"
          v-bind="getObject('cultureId')"
          label="Cultura"
          :items="extraData.accountContext.allCultures"
          item-value="id"
          item-text="name"
          no-data-text="Nenhuma cultura encontrada, faça outra busca"
          autocomplete="off"
          :disabled="readOnly">
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-bind="getObject('plantedArea')"
          :inputData.sync="entry.plantedArea"
          mask-type="13v2"
          label="Área/Qtd. Plantada"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <v-autocomplete
          v-model="entry.plantedUnitId"
          v-bind="getObject('plantedUnitId')"
          label="Unidade de Medida"
          :items="extraData.globalContext.allCustomerUnits"
          item-value="id"
          item-text="name"
          no-data-text="Nenhuma unidade de medida encontrada, faça outra busca"
          autocomplete="off"
          :disabled="readOnly">
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-bind="getObject('globalArea')"
          :inputData.sync="entry.globalArea"
          mask-type="13v2"
          label="Área Global"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <v-autocomplete
          v-model="entry.globalUnitId"
          v-bind="getObject('globalUnitId')"
          label="Unidade de Medida"
          :items="extraData.globalContext.allCustomerUnits"
          item-value="id"
          item-text="name"
          no-data-text="Nenhuma unidade de medida encontrada, faça outra busca"
          autocomplete="off"
          :disabled="readOnly">
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-bind="getObject('irrigatedArea')"
          :inputData.sync="entry.irrigatedArea"
          mask-type="13v2"
          label="Área Irrigada"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <v-autocomplete
          v-model="entry.irrigatedUnitId"
          v-bind="getObject('irrigatedUnitId')"
          label="Unidade de Medida"
          :items="extraData.globalContext.allCustomerUnits"
          item-value="id"
          item-text="name"
          no-data-text="Nenhuma unidade de medida encontrada, faça outra busca"
          autocomplete="off"
          :disabled="readOnly">
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-bind="getObject('produced')"
          :inputData.sync="entry.produced"
          mask-type="13v2"
          label="Produtividade"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <v-autocomplete
          v-model="entry.producedUnitId"
          v-bind="getObject('producedUnitId')"
          label="Unidade de Medida"
          :items="extraData.globalContext.allCustomerUnits"
          item-value="id"
          item-text="name"
          no-data-text="Nenhuma unidade de medida encontrada, faça outra busca"
          autocomplete="off"
          :disabled="readOnly">
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6">
        <v-autocomplete
          v-model="entry.technicalLevel"
          v-bind="getObject('technicalLevel')"
          label="Nível de Tecnologia"
          :items="extraData.accountContext.technicalLevels"
          item-value="id"
          item-text="name"
          no-filter
          autocomplete="off"
          :disabled="readOnly"
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField v-if="entry.isRented"
          v-bind="getObject('rentedQuantity')"
          :inputData.sync="entry.rentedQuantity"
          mask-type="13v2"
          label="Valor do Arrendamento"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12">
        <v-checkbox label="Área Arrendada" v-model="entry.isRented" :disabled="readOnly"></v-checkbox>
      </v-col>

      

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import gql from 'graphql-tag'
// import CultureNew from "@models/cultures/new.vue"
import BaseUtil from "@shared_components/base_util.vue"
// import NewItemSelect from " /new_item_select.vue"

export default {
  data() {
    return {
      entryAttributes: {},
      harvestsSearch: "",
      culturesSearch: "",
      packagingsListKey: 0,
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    // CultureNew: CultureNew,   
    BaseUtil: BaseUtil,
    // NewItemSelect: NewItemSelect,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
  },
  mounted() {
    // if (this.entry.unitId) {
    //   this.getPackagingsForUnit(false);
    // }
  },
  watch: {
    itemsSearch: function(newSearch, oldSearch) {
      // console.log(newSearch, newSearch, oldSearch, oldSearch)
      if (this.itemsSearch && this.itemsSearch.length > 0) {
        if ((!this.entry.item || this.entry.item.name != this.itemsSearch) && newSearch.length >= 3) {
          if(this.timer){
            clearTimeout(this.timer);
          }
          this.timer = setTimeout( ()=> {
            // console.log(newSearch, newSearch);
            this.getPurchaseItems();
          }, 1000);
        }
      }
    },
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    harvestSelected: function() {
      this.harvest = this.extraData.accountContext.allHarvests.filter( (item)=> item.id = this.harvestId );
      console.log(this.harvest);
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
  }
};


</script>

<style scoped></style>


